import React, { useState } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import Modal from '../common/Modal';
import Steps from '../common/Steps';
import GuideList from './GuideList';
import RecipientList from './RecipientList';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import MessageList from './MessageList';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyle = makeStyles({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  contentBox: {
    height: '60vh',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    padding: '15px 10px',
  },
});

export default function ShareGuidePopup({ isOpen, setIsOpen, dealershipId, callFrom }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [slectedJ, setSelectedJ] = useState({});
  const [slectedGuide, setSelectedGuide] = useState({});
  const [recipients, setRecipients] = useState([]);
  const [roles, setRoles] = useState([]);
  const [message, setMessage] = useState({});
  const [customMsg, setCustomMsg] = useState('');
  const [selectedEmpUnderRole, setSelectedEmpUnderRole] = useState({});
  const [selectedRoleEmp, setSelectedRoleEmp] = useState([]);

  const validation = () => {
    if (step === 1 && _isEmpty(slectedGuide)) {
      ErrorToast('Please select a guide');
      return false;
    }
    if (step === 2) {
      let empHashList = [];
      Object.keys(selectedEmpUnderRole).forEach((key) => {
        if (!roles.includes(Number(key))) {
          empHashList = empHashList.concat(selectedEmpUnderRole[key]);
        }
      });
      const temp = [...empHashList, ...selectedRoleEmp];
      setRecipients(temp);
      if (temp.length === 0 && roles.length === 0) {
        ErrorToast('Please select a recipient');
        return false;
      }
    }

    if (step === 3 && message.id === -1 && !customMsg.length) {
      ErrorToast('Please enter a custom message or unselect the Custom Message tag');
      return false;
    }
    return true;
  };

  const onNext = async () => {
    if (validation()) {
      if (step < 3) {
        setStep((pre) => pre + 1);
      }

      if (step === 3) {
        dispatch(showProgress(true));
        const payload = {
          guideId: slectedGuide.guideId,
          journeyId: slectedJ.journeyId,
          type: 1,
        };
        if (!_isEmpty(message) && message.id !== -1) {
          payload.messageData = message.message;
        } else if (!_isEmpty(message) && message.id === -1) {
          payload.messageData = customMsg;
        } else if (_isEmpty(message)) {
          payload.messageData = '';
        }
        if (recipients.length > 0) {
          payload.receiversHash = recipients;
        }
        try {
          await service.post(apiEndpoints.DEALER_SHARE_GUIDE, payload);
          notifySuccess('Guide shared successfully!');
          setIsOpen(false);
        } catch (error) {
          ErrorToast(error);
        }
        dispatch(showProgress(false));
      }
    }
  };

  return (
    <Modal isOpen={isOpen} height="85vh" width="55vw">
      <Grid className={classes.container}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '600', fontSize: '18px' }}>
              Share Guide
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Steps step={step} stepInfo={['Select a Guide', 'Select Recipients', 'Select Message']} />
        <Grid className={classes.contentBox}>
          {step === 1 && (
            <GuideList
              setSelectedGuide={setSelectedGuide}
              slectedGuide={slectedGuide}
              setSelectedJ={setSelectedJ}
              slectedJ={slectedJ}
              callFrom={callFrom}
              dealershipId={dealershipId}
            />
          )}
          {step === 2 && (
            <RecipientList
              slectedJId={slectedJ.journeyId}
              roles={roles}
              setRoles={setRoles}
              selectedEmpUnderRole={selectedEmpUnderRole}
              setSelectedEmpUnderRole={setSelectedEmpUnderRole}
              setSelectedRoleEmp={setSelectedRoleEmp}
              type="share"
              callFrom={callFrom}
              dealershipId={dealershipId}
            />
          )}
          {step === 3 && (
            <MessageList
              message={message}
              setMessage={setMessage}
              customMsg={customMsg}
              setCustomMsg={setCustomMsg}
              slectedGuide={slectedGuide}
              slectedJ={slectedJ}
            />
          )}
        </Grid>
        <Grid style={{ display: 'flex' }}>
          {step > 1 && (
            <Button
              onClick={() => {
                if (step === 2) {
                  setRecipients([]);
                  setRoles([]);
                  setSelectedEmpUnderRole({});
                  setSelectedRoleEmp([]);
                }
                if (step === 3) {
                  setMessage({});
                  setCustomMsg('');
                }
                setStep((pre) => pre - 1);
              }}
              variant="outlined"
            >
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onNext}>
                {step !== 3 ? 'Next' : 'Share'}
              </Button>
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
